module.exports = __webpack_public_path__ + "static/media/features-ic-05.7c3d2e0c.svg";